import { UntypedFormGroup } from '@angular/forms';
/**
 * Validator to check if date is 2 Moths Apart
 */
export class DateValidator {
/**
 * Check if the Date is 2 Months apart
 * @param from 
 * @param to 
 * @returns 
 */
    static is2MonthsApart(from: string, to: string) {
        console.log(from, " TO ", to)
        return (group: UntypedFormGroup): { [key: string]: any } => {
            let f = group.controls[from];
            let t = group.controls[to];
            if (f.value > t.value) {
                return {
                    dates: "Date from should be less than Date to"
                };
            }
            return {};
        }
    }
}